import React, { memo, useCallback } from 'react';
import { Box,Accordion, AccordionSummary, Typography, AccordionDetails, IconButton, Switch } from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down-2.svg"
import GraphTypesConfig from '../graph/GraphTypesConfig';
import { CustomTooltip } from '../../utils/Reusables';
import { useDispatch, useSelector } from 'react-redux';
import { reportActions } from '../../redux/reducers/report/reportReducer';


const ReportGraphTypes = ({}) => {
    const [isComparisonMode, setIsComparisonMode] = React.useState(false);
    const dispatch = useDispatch()
    const reportDetails = useSelector(state => state.reportDetails)

    const handleChartTypeChange = useCallback((graph) => {
        dispatch(reportActions.updateChartType({chartType: graph.value}))
    })
    //console.log(chartType)

    return <>
        <Box className="report-new-charts">
        <Accordion defaultExpanded className="filter_accordian re-edit-settings-visual-type">
            <AccordionSummary
            expandIcon={<DropDownIcon />}
            aria-controls="report-new-charts-content"
            id="report-new-charts-header"
            className="report-new-charts-header filter_accordian_summary"
            >
            <Typography className="re-edit-settings-visual-type-label"  variant="h4" noWrap>Visual Type</Typography>
            </AccordionSummary>
            <AccordionDetails  className="report-new-charts-items filter_accordian_details">
                {GraphTypesConfig.map((graph, i) =>
                    <CustomTooltip key={i} title={graph.label}>
                    <IconButton className='re-edit-settings-visual-type-item' variant="outlined" key={i} onClick={() => handleChartTypeChange(graph)}>
                        {graph.icon({ selected: reportDetails.chartType == graph.value })}
                    </IconButton>
                    </CustomTooltip>
                )}
                <Box className='re-edit-settings-visual-type-comparison'>
                    <Switch
                        value=""
                        checked={isComparisonMode ? true : false}
                        onChange={e => setIsComparisonMode(!isComparisonMode)}
                    />
                    <span className='switch-label'>Comparison Mode</span>
                </Box>
            </AccordionDetails>
        </Accordion>
        </Box>         
    </>
}

export default memo(ReportGraphTypes)